module.exports = __webpack_public_path__ + "img/category.4ebcbe33.svg";